import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {IAbstractOnlineChatMessagePinParam} from "~/cabinet/vue/client/events/action/types/Interface";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OnlineChatMessageFormPinParams"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {}
  },
  setup(__props: any) {

let props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createVNode(ElCardHeader, { title: "Закрепление сообщения" }),
      _createVNode(ElCardSection, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_switch, {
              modelValue: __props.value.pinMessage,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value.pinMessage) = $event)),
              class: "mr-2"
            }, null, 8, ["modelValue"]),
            _cache[4] || (_cache[4] = _createTextVNode(" Закрепить сообщение для операторов ", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_switch, {
              modelValue: __props.value.unpinOtherMessages,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.value.unpinOtherMessages) = $event)),
              class: "mr-2"
            }, null, 8, ["modelValue"]),
            _cache[5] || (_cache[5] = _createTextVNode(" Открепить другие сообщения для операторов ", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_switch, {
              modelValue: __props.value.pinMessageForClient,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.value.pinMessageForClient) = $event)),
              class: "mr-2"
            }, null, 8, ["modelValue"]),
            _cache[6] || (_cache[6] = _createTextVNode(" Закрепить сообщение для клиента ", -1))
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_switch, {
              modelValue: __props.value.unpinOtherMessagesForClient,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.value.unpinOtherMessagesForClient) = $event)),
              class: "mr-2"
            }, null, 8, ["modelValue"]),
            _cache[7] || (_cache[7] = _createTextVNode(" Открепить другие сообщения для клиента ", -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})